import moment from 'moment';
import { ApplicationTypesEnum } from 'components/ApplicationDetails/Applications/Applications.types';
import { DocSignStatus, DocStatus, DocTypes } from 'components/DocBox/DocBox.types';
import { dateFormatZurich, formatDate } from 'utils/datetime';
import { getOrderType } from 'pages/ClientOverview/pages/Portfolios/pages/SinglePortfolioView/pages/Cases/components/CasesTable/adaptor';
import { THREEBTYPES } from 'constants/constants';

export const adaptCaseDetailsData = ({
    caseData, externalCaseData, portfolioData, planData, documents, language, fromDL, t, submittedCase, reasonForSaleOptions,
}) => {
    const getStatus = (status) => {
        switch (status) {
            case DocSignStatus.notSigned:
                return DocStatus.ReadyToSign;
            case DocSignStatus.esignInProgress:
                return DocStatus.ReadyToSign;
            case DocSignStatus.signed:
                return DocStatus.ReadyToSubmit;
            default:
                return '';
        }
    };

    const submittedDate = externalCaseData?.submittedOn || caseData?.submittedOn;

    return {
        id: caseData?.id,
        portfolioId: caseData?.portfolioId,
        status: externalCaseData?.status || caseData?.status || '-',
        type: ApplicationTypesEnum.SELL,
        typeKey: '',
        productName: portfolioData?.strategy || '-',
        productNameTranslated: portfolioData?.productName || '-',
        productExternalId: portfolioData?.productExternalId || '-',
        advisor: portfolioData?.advisor || '-',
        createdBy: fromDL ? 'VIO' : (caseData?.createdBy?.fullName || '-'),
        submitted: submittedDate ? formatDate(submittedDate, dateFormatZurich) : '-',
        submittedBy: caseData?.submittedBy?.fullName || '-',
        depotNumber: planData?.portfolioName || '-',
        investedAmount: caseData?.investedAmount,
        amountToBeSold: caseData?.amount,
        remainingAmount: caseData?.investedAmount - caseData?.amount,
        documents: documents?.map(document => ({
            status: getStatus(document?.signStatus),
            type: DocTypes.GENERATE,
            documentId: document?.id,
            documentName: document?.metadataName || document?.documentName || '',
            signStatus: document?.signStatus || DocSignStatus.notSigned,
        })),
        partialSale: +caseData?.orderType === 1,
        closeAccount: caseData?.pkNeedCloseAccount,
        issueCommission: caseData?.pkPayIssueCommission,
        isSignatureVerified: caseData?.isSignatureVerified || submittedCase,
        rubrik: '',
        lpzCaseId: externalCaseData?.lpzCaseId,
        createdOn: moment(externalCaseData?.createdOn).format(dateFormatZurich),
        orderType: t(getOrderType({ isPk: portfolioData?.productExternalId === THREEBTYPES.pk, orderType: externalCaseData?.type })),
        isEmailRetention: caseData?.isEmailRetention,
        submittedCase,
        reasonForSale: reasonForSaleOptions?.find(option => option?.value === caseData?.reasonListItemId?.toString())?.label || '',
        reasonText: caseData?.reasonText || '',
        fromDL,
    };
};
